import { getLogger } from "@expert/logging";
import { getGamificationApiClient } from "@/sales-tools/home-product/api/api";
import { getSelectedSessionId } from "@/sdk";
import type { Reaction } from "../../models";

const logger = getLogger({
    module: "send-reaction",
    supportTeam: "sales",
});

export const sendReaction = async (targetExpertId: string, reactionType: Reaction) => {
    const childLogger = logger.child({ targetExpertId, reactionType, sessionId: getSelectedSessionId() });
    try {
        logger.info("Sending reaction");
        return await getGamificationApiClient()
            .post("v1/reaction", { json: { targetExpertId, reactionType } })
            .json<boolean>();
    } catch (err: unknown) {
        childLogger.error({ err }, "sendReaction failure");
        return false;
    }
};
